import { useEffect, useState } from 'react';
// material
import { styled } from '@mui/material/styles';
import {
  Box,
  Container,
  Typography,
  Dialog,
  DialogTitle,
  Button,
  DialogContent,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
// components
import Page from '../../components/Page';
import UserAfterRegistrationForm from '../../components/_dashboard/user/UserAfterRegistrationForm';
import { useUpdateInviationMutation } from '../../redux/slices/api';
import useAuth from '../../hooks/useAuth';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  display: 'flex',
  minHeight: '100%',
  alignItems: 'center',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function UserAfterRegistration({ isInvitationApprove, id }) {
  const { getRefreshedJWT } = useAuth();

  const [showDialog, setShowDialog] = useState(true);
  const [isAgreeing, setIsAgreeing] = useState(false);
  const [isDeclining, setIsDeclining] = useState(false);
  const [updateInvitation] = useUpdateInviationMutation();

  const handleInvite = async (isApproved) => {
    if (isApproved) setIsAgreeing(true);
    else setIsDeclining(true);
    const invitationData = {
      id: parseInt(id, 10),
      payload: { is_approved: isApproved },
    };
    await updateInvitation(invitationData);
    setTimeout(async () => {
      getRefreshedJWT();
    }, 1000);

    setIsAgreeing(false);
    setIsDeclining(false);
    setShowDialog(false);
  };

  return (
    <RootStyle title="Verify | Earlymark Select">
      <Container>
        {isInvitationApprove && (
          <Dialog
            onClose={() => setShowDialog(false)}
            open={showDialog}
            fullWidth
            maxWidth="lg"
            PaperProps={{
              sx: {
                minHeight: '25vh',
                maxHeight: '25vh',
              },
            }}
          >
            <DialogTitle sx={{ fontSize: '30px' }}>Join company</DialogTitle>
            <DialogContent>
              Please agree to our{' '}
              <a
                href="https://earlymark.com/policies/terms-of-use/"
                target="_blank"
                rel="noreferrer"
              >
                terms and conditions
              </a>{' '}
              to join.
              <Box sx={{ mt: 6, display: 'flex', justifyContent: 'center' }}>
                <LoadingButton
                  variant="contained"
                  loading={isAgreeing}
                  onClick={() => {
                    handleInvite(true);
                  }}
                  sx={{ mr: 2 }}
                >
                  Agree
                </LoadingButton>
                <LoadingButton
                  variant="contained"
                  loading={isDeclining}
                  onClick={() => {
                    handleInvite(false);
                  }}
                >
                  Decline
                </LoadingButton>
              </Box>
            </DialogContent>
          </Dialog>
        )}
        <Box sx={{ maxWidth: 480, mx: 'auto' }}>
          <Typography variant="h3" paragraph>
            Please enter your name
          </Typography>

          <Box sx={{ mt: 5, mb: 3 }}>
            <UserAfterRegistrationForm />
          </Box>
        </Box>
      </Container>
    </RootStyle>
  );
}
